import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

function Checkbox({
  id,
  className,
  inputClassName,
  labelClassName,
  label,
  name,
  isChecked,
  onToggle,
  disabled,
  required,
  isSwitch,
  linkText,
  onLinkLabel,
  labelLinkClassName,
  showError,
  error
}) {
  return (
    <div
      className={cn(className, {
        [styles.checkboxContainer]: !isSwitch,
        [styles.switchContainer]: isSwitch
      })}>
      <div className={styles.inputAndLabel}>
        <input
          className={cn(styles.checkbox, inputClassName)}
          type="checkbox"
          id={id || label}
          name={name}
          value={label}
          checked={isChecked}
          onChange={onToggle}
          disabled={disabled}
          required={required}
        />
        {label && (
          <label
            className={cn('row middle', styles.checkboxLabel, labelClassName, {
              [styles.disabled]: disabled,
              [styles.hideText]: label === id,
              [styles.labelError]: !!error
            })}
            htmlFor={label}>
            {label}
            {linkText && (
              <div
                onClick={onLinkLabel}
                className={`${labelClassName} ${labelLinkClassName}`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: linkText }}
              />
            )}
          </label>
        )}
      </div>
      {showError && (
        <p
          className={cn(styles.checkboxError, {
            [styles.showError]: !!error
          })}>
          {error}
        </p>
      )}
    </div>
  );
}

Checkbox.defaultProps = {
  className: '',
  error: '',
  inputClassName: '',
  labelClassName: '',
  showError: false
};

Checkbox.propTypes = {
  isSwitch: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  id: PropTypes.string,
  inputClassName: PropTypes.string,
  isChecked: PropTypes.bool,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  labelLinkClassName: PropTypes.string,
  linkText: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  showError: PropTypes.bool,
  onLinkLabel: PropTypes.func
};

export default Checkbox;
